import React from "react";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="relative pt-32 pb-16 flex items-center justify-center bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID OVERLAY */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      {/* Content */}
      <div className="relative z-10 text-center max-w-6xl px-6">
        <p className="text-orange-500 font-medium tracking-wide mb-3">
          Digital Marketing Agency
        </p>

        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white leading-tight">
          Grow Your Business With Smart Digital Marketing
        </h1>

        <p className="mt-5 text-lg text-gray-600 dark:text-gray-400">
          We help brands generate leads, increase sales, and build strong online
          presence through SEO, social media marketing, paid ads, and
          conversion-focused strategies.
        </p>

        <p className="mt-3 text-sm text-gray-500 dark:text-gray-500">
          SEO • Google Ads • Social Media • Meta Ads • Branding • Lead
          Generation
        </p>

        {/* CTA Buttons */}
        <div className="mt-8 flex gap-4 justify-center flex-wrap">
          <Link
            to="https://webxsecure.in/contact"
            className="px-6 py-3 rounded-xl bg-primary text-white font-medium hover:scale-105 transition"
          >
            Get Free Consultation
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
